import React from 'react';
import { useTranslation } from 'react-i18next';
import './TermsConditions.css';

const TermsConditions = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  return (
    <div className={`terms-conditions ${isRTL ? 'rtl' : 'ltr'}`}>
      <div className="container">
        <div className="terms-header">
          <h1>{t('terms.title')}</h1>
          <p className="last-updated">{t('terms.lastUpdated')}: {t('terms.date')}</p>
        </div>

        <div className="terms-content">
          <section className="terms-section">
            <h2>{t('terms.section1.title')}</h2>
            <p>{t('terms.section1.content')}</p>
          </section>

          <section className="terms-section">
            <h2>{t('terms.section2.title')}</h2>
            <p>{t('terms.section2.content')}</p>
            <ul>
              <li>{t('terms.section2.item1')}</li>
              <li>{t('terms.section2.item2')}</li>
              <li>{t('terms.section2.item3')}</li>
              <li>{t('terms.section2.item4')}</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>{t('terms.section3.title')}</h2>
            <p>{t('terms.section3.content')}</p>
          </section>

          <section className="terms-section">
            <h2>{t('terms.section4.title')}</h2>
            <p>{t('terms.section4.content')}</p>
            <ul>
              <li>{t('terms.section4.item1')}</li>
              <li>{t('terms.section4.item2')}</li>
              <li>{t('terms.section4.item3')}</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>{t('terms.section5.title')}</h2>
            <p>{t('terms.section5.content')}</p>
          </section>

          <section className="terms-section">
            <h2>{t('terms.section6.title')}</h2>
            <p>{t('terms.section6.content')}</p>
          </section>

          <section className="terms-section">
            <h2>{t('terms.section7.title')}</h2>
            <p>{t('terms.section7.content')}</p>
          </section>

          <section className="terms-section">
            <h2>{t('terms.section8.title')}</h2>
            <p>{t('terms.section8.content')}</p>
            <div className="contact-info">
              <p>
                {t('terms.contact.email')}: <a href="mailto:legal@baleeg-om.com">legal@baleeg-om.com</a>
              </p>
              <p>
                {t('terms.contact.phone')}: <a href="tel:+96896758894">+968-96758894</a>
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;